import back_icon from './img/back_icon.svg'
import { TitlePage } from '../../TitlePage/TitlePage'
import './Productinfopanel.scss'

const parse = require('html-react-parser')

const INFO_ITEMS = [
    { label: 'Артикул', key: 'offer_id' },
    { label: 'Категория', key: 'category_name' },
    { label: 'Бренд', key: 'brand_name' },
    { label: 'Магазин', key: 'store_name' },
]

const RATING_ITEMS = [
    { label: 'Кол-во отзывов по товару', key: 'feedback_count' },
    { label: 'Количество плохих отзывов', key: 'bad_values' },
    { label: 'Количество хороших отзывов', key: 'good_values' },
    { label: 'Средний рейтинг по товару', key: 'avg_product_valuation' },
    { label: 'Средний рейтинг по товару за 30 дней', key: 'avg_product_valuation_30d' },
    { label: 'Средний рейтинг по товару за все время', key: 'avg_product_valuation_all' },
    { label: 'Изменение среднего рейтинга', key: 'avg_product_valuation_change' },
    { label: 'Дней без плохих отзывов', key: 'date_count_without_bad' },
]

const ProductInfoPanel = ({
    isShowInformation,
    setIsShowInformation,
    productGlobalInfo
}) => {

    return (
        <div className={isShowInformation ? 'product-info-panel' : 'product-info-panel_hide'}>
            <button className='btn-back' onClick={() => setIsShowInformation(false)}>
                <img src={back_icon} />
            </button>



            {productGlobalInfo?.error ?
                'Что-то пошло не так. Попробуйте еще раз'
                :
                <>
                    <div className='product-info-panel__info-content'>
                        <TitlePage
                            medium
                            style={{ fontSize: '12px', fontWeight: 700 }}
                            title='ОБЩАЯ ИНФОРМАЦИЯ'
                        />

                        {INFO_ITEMS.map(({ label, key }) => (
                            <div key={key} className='product-info-panel__item'>
                                <p className='product-info-panel__text-label'>{label}</p>
                                <p className='product-info-panel__text-value-blue'>{productGlobalInfo?.[key]}</p>
                            </div>
                        ))}
                    </div>

                    <div className='product-info-panel__info-content'>
                        <TitlePage
                            medium
                            style={{ fontSize: '12px', fontWeight: 700 }}
                            title='ДИНАМИКА РЕЙТИНГА'
                        />

                        {RATING_ITEMS.map(({ label, key }) => (
                            <div key={key} className='product-info-panel__item'>
                                <p className='product-info-panel__text-label'>{label}</p>
                                <p className='product-info-panel__text-value'>{productGlobalInfo?.[key]}</p>
                            </div>
                        ))}
                    </div>

                    <div className='product-info-panel__info-content'>
                        <TitlePage
                            medium
                            style={{ fontSize: '12px', fontWeight: 700 }}
                            title='ОПИСАНИЕ ТОВАРА'
                        />

                        <div className='product-info-panel__item'>
                            <p className='product-info-panel__text-value' style={{ textAlign: 'left', }}>
                                {productGlobalInfo?.description ? parse(productGlobalInfo?.description) : '-'}
                            </p>
                        </div>
                    </div>

                    <div className='product-info-panel__info-content'>
                        <TitlePage
                            medium
                            style={{ fontSize: '12px', fontWeight: 700 }}
                            title='КАТЕГОРИЗАЦИЯ'
                        />

                        <div className='product-info-panel__item'>
                            <p className='product-info-panel__text-value' style={{ textAlign: 'left' }}>
                                {productGlobalInfo?.attributes?.join(', ')}
                            </p>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export { ProductInfoPanel }